
import React, { useEffect, useState } from 'react'
import Loader from "../../Loader";
import Select from 'react-select';
 
const OrderDetailFilter = ({detail, carriers, onFilter, role}) => {

    const [tnNumberList, setTnNumberList] = useState([]);
    const [uniqueCarrierList, setUniqueCarrierList] = useState([]);
    const [carrierFilterList, setCarrierFilterList] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);  
    const [selectedNumber, setSelectedNumber] = useState(''); 
    const [selectCarrier, setSelectCarrier] = useState('');
    const [numberStatus, setNumberStatus] = useState('');
    const [overallStatus, setOverallStatus] = useState("");
    const [sansayStatus, setSansayStatus] = useState('');
    const [romeStatus, setRomeStatus] = useState('');
    const [cnameStatus, setCnameStatus] = useState('');
    const [e911Status, setE911Status] = useState('');
    const [carrierDisplay, setCarrierDisplay] = useState(false);
    const [featureDisplay, setFeatureDisplay] = useState(false);
    const [numberDisplay, setNumberDisplay] = useState(false);
    const [sansayDisplay, setSansayDisplay] = useState(false);
    const [romeDisplay, setRomeDisplay] = useState(false);
    const [e911Display, setE911Display] = useState(false);
   
    useEffect(() => {
        if(detail?.tn_details?.length > 0){
            setUniqueCarrierList([...new Set(detail?.tn_details.map(item => item.number_type))] ?? []);
            setTnNumberList(detail?.tn_details.map((item) => item.tn_number));
            if((detail.order_type == 0 && detail?.tn_details.filter((item) => item.cname_flag == 1).length > 0))
            {
                setNumberDisplay(true);
                setFeatureDisplay(true);
                setSansayDisplay(true);
                setRomeDisplay(true);
            }
            if(detail.order_type == 3){
                setFeatureDisplay(true);
                setSansayDisplay(true);
                setRomeDisplay(true);
            }
            if(detail.order_type == 0 || detail.order_type == 2){
               
                setNumberDisplay(true);
                setSansayDisplay(true);
                setRomeDisplay(true);
            }
            if(detail.order_type == 4 || detail.order_type == 5){
               
                setSansayDisplay(true);
            }
            
        }
        
    }, [detail]);

    useEffect(() => {
        if(carriers && uniqueCarrierList.length > 0){
            const carrierFilterList = uniqueCarrierList.map(value => {
                if (value == 0) {
                    return { id: 0, name: "Inteliquent" };
                } else if (value == 1) {
                    return { id: 1, name: "Bandwidth" };
                } else {
                    const carrier = carriers.find(item => item.carrier_index == value);
                    if(carrier){
                        return { id: carrier.carrier_index, name: carrier.name };
                    }
                }
            });
            // order_type 7 (Bandwidth/VB international) orders belong to a single pseudo-carrier,
            // so a carrier filter built from number_type would show misleading options
            if(carrierFilterList.length > 1 && (detail.order_type != 4 && detail.order_type != 5 && detail.order_type != 7)){
                setCarrierDisplay(true);
            }
            setCarrierFilterList(carrierFilterList);
            
        }
    }, [carriers, uniqueCarrierList]);
    
    

    const handleSearchSubmit = () => {
        let obj = {};
        obj.overallStatus = overallStatus;
        if(selectCarrier){
            obj.selectCarrier = selectCarrier;
        }
        if(selectedNumber){
            obj.selectedNumber = selectedNumber;
        }
        if(numberStatus){
            obj.numberStatus = numberStatus;
        }
        if(sansayStatus){
            obj.sansayStatus = sansayStatus;
        }
        if(romeStatus){
            obj.romeStatus = romeStatus;
        }
        if(cnameStatus){
            obj.cnameStatus = cnameStatus;
        }
        if(e911Status){
            obj.e911Status = e911Status;
        }
        onFilter(obj);
    };

    const handleClear = () => {
        setOverallStatus('');
        setNumberStatus('');
        setSansayStatus('');
        setRomeStatus('');
        setCnameStatus('');
        setE911Status('');
        onFilter({});
    }

    
    return (
        <>
        <div className="col-md-12 order-filter transection-filter">
            <div className="boxinput">
                {popupOpen && (<Loader /> )}
                 <select className="company-name form-control orderStatus" name="overall_status" value={overallStatus} onChange={(e) => setOverallStatus(e.target.value)}>
                    <option value="">Overall Status</option>
                    <option value="1">Complete</option>
                    {detail.order_type != 2 && <option value="2">Failed</option>}
                    {detail.order_type == 2 && <option value="2">Needs Review</option>}
                    {detail.order_type != 2 && <option value="needs_review">Needs Review</option>}
                    <option value="0">In-Progress</option>
                    <option value="3">Manually Completed</option>
                </select>
                {role <=2 && carrierDisplay && <select className="company-name form-control orderStatus" name="carrier_status" value={selectCarrier} onChange={(e) => setSelectCarrier(e.target.value)}>
                    <option value="">Carrier List</option>
                    {carrierFilterList.length > 0 && carrierFilterList.map((item) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                    ))}
                </select>}
                {role <=2 && numberDisplay && <select className="company-name form-control orderStatus" name="number_status" value={numberStatus} onChange={(e) => setNumberStatus(e.target.value)}>
                    <option value="">Carrrier Status</option>
                    <option value="1">Complete</option>
                    <option value="2">{detail.order_type == 2 ? 'Needs Review' : 'Failed'}</option>
                    <option value="0">In-Progress</option>
                    <option value="3">Manually Completed</option>
                </select>}
                {role <=2 && sansayDisplay && <select className="company-name form-control orderStatus" name="sansay_status" value={sansayStatus} onChange={(e) => setSansayStatus(e.target.value)}>
                    <option value="">Sansay Status</option>
                    <option value="1">Complete</option>
                    <option value="2">Needs Review</option>
                    <option value="0">In-Progress</option>
                    <option value="3">Manually Completed</option>
                </select>}
                {role <=2 && romeDisplay &&<select className="company-name form-control orderStatus" name="rome_status" value={romeStatus} onChange={(e) => setRomeStatus(e.target.value)}>
                    <option value="">Rome Status</option>
                    <option value="1">Complete</option>
                    <option value="2">Needs Review</option>
                    <option value="0">In-Progress</option>
                    <option value="3">Manually Completed</option>
                </select>}
                {role <=2 && featureDisplay && <select className="company-name form-control orderStatus" name="rome_status" value={cnameStatus} onChange={(e) => setCnameStatus(e.target.value)}>
                    <option value="">Cnam Status</option>
                    <option value="1">Complete</option>
                    <option value="2">Needs Review</option>
                    <option value="0">In-Progress</option>
                    <option value="3">Manually Completed</option>
                </select>}
                {role <=2 && e911Display && <select className="company-name form-control orderStatus" name="e911_status" value={e911Status} onChange={(e) => setE911Status(e.target.value)}>
                    <option value="">E911 Status</option>
                    <option value="1">Complete</option>
                    <option value="2">Needs Review</option>
                    <option value="0">In-Progress</option>
                </select>}
               <button  className="search-btn" onClick={handleSearchSubmit} >Search</button>
               { (overallStatus || numberStatus ||  sansayStatus || romeStatus || cnameStatus || e911Status) && (<a className='search-btn clear-btn'  onClick={handleClear}>Clear</a>)}
            </div>
        </div>
        </>
    )
}
 
export default OrderDetailFilter
